import { CalculatorIcon, LightningBoltIcon, BeakerIcon, SparklesIcon, FileTextIcon, GlobeIcon, MapIcon } from './components/icons';
import { ScaleResult } from './types';

export const MOCK_SCALES_EMPTY: ScaleResult = {
  studyHabits: { name: "Verimli Ders Çalışma", maxScore: 100, current: null, history: [], consultantNotes: "" },
  attention: { name: "Dikkat", maxScore: 100, current: null, history: [], consultantNotes: "" },
  anxiety: { name: "Sınav Kaygısı", maxScore: 175, current: null, history: [], consultantNotes: "" },
  readingComprehension: { name: "Okuma-Anlama", maxScore: 100, current: null, history: [], consultantNotes: "" },
  careerInterest: { name: "Mesleki Eğilim (Holland)", maxScore: 30, current: null, history: [], consultantNotes: "" },
  parentStudyHabits: { name: "Veli Ders Çalışma Gözlemi", maxScore: 100, current: null, history: [], consultantNotes: "" }
};

export const ONBOARDING_QUESTIONS = {
  demographics: [
    { id: 4, label: "Hangi alanda eğitim görüyorsunuz?", options: ["Sayısal", "Eşit Ağırlık", "Sözel", "Dil"] },
    { id: 2, label: "Sınıf", options: ['5. Sınıf', '6. Sınıf', '7. Sınıf', '8. Sınıf', '9. Sınıf', '10. Sınıf', '11. Sınıf', '12. Sınıf', 'Mezun'] },
    { id: 3, label: "Hedefinizdeki üniversite/bölüm nedir?", type: "text" }
  ],
  recognition: [
    { id: 'academicInterests', label: 'En sevdiğin dersler hangileri?', type: 'text' },
    { id: 'strongSubjects', label: 'Kendini en başarılı hissettiğin dersler?', type: 'text' },
    { id: 'weakSubjects', label: 'En çok zorlandığın dersler?', type: 'text' },
  ],
  studyHabits: {
    questions: [
      { text: "Haftalık ve günlük çalışma planım vardır.", category: "Planlama" },
      { text: "Planıma sadık kalmakta zorlanmam.", category: "Planlama" },
      { text: "Ders çalışmaya başlamadan önce ne çalışacağımı belirlerim.", category: "Planlama" },
      { text: "Çalışma süremi verimli kullanırım, sık sık ara vermem.", category: "Planlama" },
      { text: "Çalışma masam düzenlidir ve sadece ders materyalleri bulunur.", category: "Ortam" },
      { text: "Gürültülü ortamlarda da ders çalışabilirim.", category: "Ortam" },
      { text: "Çalışma odam yeterince aydınlık ve havadardır.", category: "Ortam" },
      { text: "Yatarak veya uzanarak ders çalışmam.", category: "Ortam" },
      { text: "Telefonumu ders çalışırken sessize alırım veya başka odaya bırakırım.", category: "Ortam" },
      { text: "Ders çalışırken düzenli not tutarım.", category: "Teknikler" },
      { text: "Konu tekrarı yapmadan soru çözmeye geçmem.", category: "Teknikler" },
      { text: "Pomodoro gibi zaman yönetimi teknikleri kullanırım.", category: "Teknikler" },
      { text: "Önemli yerlerin altını çizerim veya renkli kalem kullanırım.", category: "Teknikler" },
      { text: "Anlamadığım yerleri belirler ve öğretmenime sorarım.", category: "Teknikler" },
      { text: "Farklı kaynaklardan yararlanırım.", category: "Teknikler" },
      { text: "Deneme sınavlarından sonra mutlaka analiz yaparım.", category: "Teknikler" },
      { text: "Başarılı olacağıma inancım tamdır.", category: "Motivasyon" },
      { text: "Ders çalışmaktan sıkıldığımda kendimi motive edebilirim.", category: "Motivasyon" },
      { text: "Hedeflerimi sık sık gözden geçiririm.", category: "Motivasyon" },
      { text: "Başarısızlık durumunda pes etmem, hatalarımdan ders çıkarırım.", category: "Motivasyon" }
    ]
  },
  attention: {
    questions: [
      { text: "Ders çalışırken aklım sık sık başka yerlere gider.", category: "İçsel Odak" },
      { text: "Bir konuya odaklanmakta zorlanırım.", category: "İçsel Odak" },
      { text: "Detaylara dikkat etmekte zorlanırım, basit hatalar yaparım.", category: "İçsel Odak" },
      { text: "Dışarıdaki en ufak ses dikkatimi dağıtır.", category: "Dışsal Odak" },
      { text: "Telefon veya bildirimler dikkatimi hemen çeker.", category: "Dışsal Odak" },
      { text: "Karşılıklı konuşurken dinlemiyormuş gibi görünürüm.", category: "Dışsal Odak" },
      { text: "Başladığım işi bitirmeden bırakırım.", category: "Sürdürülebilirlik" },
      { text: "Okuduğum paragrafın başını sonuna gelince unuturum.", category: "Sürdürülebilirlik" },
      { text: "Eşyalarımı sık sık kaybederim veya unuturum.", category: "Sürdürülebilirlik" },
      { text: "Uzun süre zihinsel çaba gerektiren işlerden kaçınırım.", category: "Sürdürülebilirlik" }
    ]
  },
  anxiety: {
    questions: [
      { text: "Sınav sırasında ellerim titrer veya midem bulanır.", category: "Fizyolojik" },
      { text: "Kalp atışlarım sınav anında çok hızlanır.", category: "Fizyolojik" },
      { text: "Sınavdan önceki gece uyumakta zorlanırım.", category: "Fizyolojik" },
      { text: "Sınav yaklaştıkça iştahım kapanır veya aşırı artar.", category: "Fizyolojik" },
      { text: "Sınav sonuçları açıklanırken aşırı heyecanlanırım.", category: "Fizyolojik" },
      { text: "Sınavda bildiğim her şeyi unutacakmışım gibi hissederim.", category: "Bilişsel" },
      { text: "Başarısız olursam ailemin yüzüne bakamam diye düşünürüm.", category: "Bilişsel" },
      { text: "Sınav süresinin yetmeyeceğinden sürekli endişe ederim.", category: "Bilişsel" },
      { text: "Sınav anında zihnimin boşaldığını hissederim.", category: "Bilişsel" },
      { text: "Sınavda diğer öğrencilerin benden daha hızlı çözdüğünü düşünürüm.", category: "Bilişsel" }
    ]
  },
  readingComprehension: {
    text: "Uyku, insan yaşamının yaklaşık üçte birini kapsayan, aktif ve hayati bir süreçtir. Beynin ve vücudun dinlenmesi, yenilenmesi ve gelişimini sürdürmesi için gereklidir. Uyku sırasında beyin, gün içinde edinilen bilgileri işler ve hafızaya kaydeder. Yetersiz uyku, dikkat eksikliği, öğrenme güçlüğü ve duygusal dengesizlik gibi sorunlara yol açabilir. Bu nedenle, düzenli ve kaliteli uyku, hem fiziksel hem de zihinsel sağlık için kritik öneme sahiptir.",
    questions: [
      {
        id: 1,
        paragraph: "",
        question: "Metne göre uyku neden gereklidir?",
        options: ["Sadece rüya görmek için", "Zaman geçirmek için", "Beynin ve vücudun yenilenmesi için", "Daha az yemek yemek için"],
        correctAnswer: "Beynin ve vücudun yenilenmesi için",
        rationale: "Metinde 'Beynin ve vücudun dinlenmesi, yenilenmesi ve gelişimini sürdürmesi için gereklidir' ifadesi geçmektedir.",
        hint: "Metnin ikinci cümlesine odaklanın."
      },
      {
        id: 2,
        paragraph: "",
        question: "Yetersiz uykunun sonuçlarından biri aşağıdakilerden hangisidir?",
        options: ["Daha hızlı koşmak", "Dikkat eksikliği", "Daha çok kitap okumak", "Yüksek sesle konuşmak"],
        correctAnswer: "Dikkat eksikliği",
        rationale: "Metinde yetersiz uykunun dikkat eksikliğine yol açabileceği belirtilmiştir.",
        hint: "Sonlara doğru geçen olumsuz etkilere bakın."
      }
    ]
  }
};

export const EXAM_TOPICS = {
  TYT: {
    "Türkçe": [
      "Sözcükte Anlam",
      "Cümlede Anlam",
      "Paragrafta Anlam",
      "Paragrafın Yapısı",
      "Ses Bilgisi",
      "Yazım Kuralları",
      "Noktalama İşaretleri",
      "Biçim Bilgisi",
      "İsim",
      "Sıfat",
      "Zamir",
      "İsim ve Sıfat Tamlamaları",
      "Zarf",
      "Edat, Bağlaç, Ünlem",
      "Fiilde Kip",
      "Ek-Fiil",
      "Fiilde Yapı",
      "Fiilimsiler",
      "Fiilde Çatı",
      "Cümlenin Ögeleri",
      "Cümle Türleri",
      "Anlatım Bozuklukları"
    ],
    "Matematik": [
      "Temel Kavramlar",
      "Sayı Basamakları",
      "Bölünebilme Kuralları",
      "OBEB-OKEK",
      "Rasyonel Sayılar",
      "Basit Eşitsizlikler",
      "Mutlak Değer",
      "Üslü Sayılar",
      "Köklü Sayılar",
      "Çarpanlara Ayırma",
      "Oran-Orantı",
      "Denklem Çözme",
      "Problemler",
      "Kümeler",
      "Mantık",
      "Fonksiyonlar",
      "Polinomlar",
      "Permütasyon-Kombinasyon",
      "Olasılık",
      "Veri – İstatistik"
    ],
    "Geometri": [
      "Açılar ve Üçgenler",
      "Çokgenler",
      "Yamuk",
      "Eşkenar Dörtgen",
      "Deltoid",
      "Kare",
      "Dikdörtgen",
      "Çember ve Daire",
      "Analitik Geometri",
      "Katı Cisimler"
    ],
    "Fizik": [
      "Fizik Bilimine Giriş",
      "Madde Ve Özellikleri",
      "Hareket ve Kuvvet",
      "İş, Güç ve Enerji I",
      "Isı, Sıcaklık ve Genleşme",
      "Elektrostatik",
      "Elektrik ve Manyetizma",
      "Basınç",
      "Kaldırma Kuvveti",
      "Dalgalar",
      "Optik"
    ],
    "Kimya": [
      "Kimya Bilimi",
      "Atomun Yapısı",
      "Periyodik Tablo",
      "Maddenin Halleri",
      "Kimyasal Türler Arası Etkileşimler",
      "Kimyasal Hesaplamalar",
      "Kimyanın Temel Kanunları",
      "Asit, Baz ve Tuz",
      "Karışımlar",
      "Kimya Her Yerde"
    ],
    "Biyoloji": [
      "Canlıların Ortak Özellikleri",
      "Canlıların Temel Bileşenleri",
      "Hücre ve Organelleri",
      "Madde Geçişleri",
      "Canlıların Sınıflandırılması",
      "Hücre Bölünmeleri ve Üreme",
      "Kalıtım",
      "Ekosistem Ekoloji",
      "Bitkiler Biyolojisi"
    ],
    "Tarih": [
      "Tarih ve Zaman",
      "İlk ve Orta Çağlarda Türk Dünyası",
      "İslam Medeniyetinin Doğuşu ve İlk İslam Devletleri",
      "Türklerin İslamiyet’i Kabulü ve İlk Türk İslam Devletleri",
      "Beylikten Devlete Osmanlı",
      "Dünya Gücü Osmanlı",
      "Değişim Çağında Avrupa ve Osmanlı",
      "Uluslararası İlişkilerde Denge Stratejisi (1774-1914)",
      "XX. Yüzyıl Başlarında Osmanlı Devleti ve Dünya",
      "Milli Mücadele",
      "Atatürkçülük ve Türk İnkılabı"
    ],
    "Coğrafya": [
      "Doğa ve İnsan",
      "Dünya’nın Şekli ve Hareketleri",
      "Coğrafi Konum",
      "Harita Bilgisi",
      "İklim Bilgisi",
      "İç ve Dış Kuvvetler",
      "Nüfus ve Yerleşme",
      "Türkiye’nin Yer Şekilleri",
      "Ekonomik Faaliyetler",
      "Bölgeler",
      "Uluslararası Ulaşım Hatları",
      "Doğal Afetler"
    ],
    "Felsefe": [
      "Felsefe’nin Konusu",
      "Bilgi Felsefesi",
      "Bilim Felsefesi",
      "Varlık Felsefesi",
      "Ahlak Felsefesi",
      "Siyaset Felsefesi",
      "Din Felsefesi",
      "Sanat Felsefesi"
    ],
    "Din Kültürü": [
      "Bilgi ve İnanç",
      "Din ve İslam",
      "İslam ve İbadet",
      "Gençlik ve Değerler",
      "Allah İnsan İlişkisi",
      "Hz. Muhammed (S.A.V)",
      "Vahiy ve Akıl",
      "İslam Düşüncesinde İtikadi, Siyasi ve Fıkhi Yorumlar",
      "Din, Kültür ve Medeniyet"
    ]
  },
  AYT: {
    "Matematik": [
      "Temel Kavramlar",
      "Sayı Basamakları",
      "Üslü Sayılar",
      "Bölme ve Bölünebilme",
      "Fonksiyonlar",
      "2. Dereceden Denklemler",
      "Mantık",
      "Parabol",
      "Trigonometri",
      "Karmaşık Sayılar",
      "Polinomlar",
      "Logaritma",
      "Diziler",
      "Permütasyon- Kombinasyon- Olasılık- Binom",
      "Limit",
      "Türev",
      "İntegral",
      "Köklü Sayılar",
      "Kümeler ve Kartezyen Çarpım",
      "Basit Eşitsizlikler",
      "Mutlak Değer",
      "EBOB-EKOK",
      "Çarpanlara Ayırma"
    ],
    "Geometri": [
      "Doğruda ve Üçgende Açı",
      "Özel Üçgenler",
      "Açıortay ve Kenarortay",
      "Açı Kenar Bağlantıları",
      "Üçgende Alan ve Benzerlik",
      "Çokgenler",
      "Noktanın Analitiği",
      "Doğrunun Analitiği",
      "Dönüşüm Geometrisi",
      "Çember ve Daire",
      "Özel Dörtgenler",
      "Katı Cisimler",
      "Çemberin Analitiği"
    ],
    "Fizik": [
      "Vektörler",
      "Bağıl Hareket",
      "Newton’un Hareket Yasaları",
      "Bir Boyutta Sabit İvmeli Hareket",
      "İki Boyutta Hareket",
      "Enerji ve Hareket",
      "İtme ve Çizgisel Momentum",
      "Tork",
      "Denge ve Denge Şartları",
      "Basit Makineler",
      "Elektriksel Kuvvet ve Elektrik Alan",
      "Elektriksel Potansiyel",
      "Düzgün Elektrik Alan ve Sığa",
      "Manyetizma ve Elektromanyetik İndüklenme",
      "Alternatif Akım",
      "Transformatörler",
      "Düzgün Çembersel Hareket",
      "Dönerek Öteleme Hareketi",
      "Açısal Momentum",
      "Kütle Çekim Kuvveti",
      "Kepler Kanunları",
      "Basit Harmonik Hareket",
      "Dalgalarda Kırınım, Girişim ve Doppler",
      "Elektromanyetik Dalgalar",
      "Atom Kavramının Tarihsel Gelişimi",
      "Büyük Patlama ve Evrenin Oluşumu",
      "Radyoaktivite",
      "Özel Görelilik",
      "Kuantum Fiziğine Giriş",
      "Fotoelektrik Olayı",
      "Compton Saçılması ve De Broglie",
      "Görüntüleme Teknolojileri",
      "Yarı İletken Teknolojisi",
      "Süper İletkenler",
      "Nanoteknoloji",
      "Lazer Işınları"
    ],
    "Kimya": [
      "Atomun Kuantum Modeli",
      "Periyodik Özellikler",
      "Yükseltgenme Basamakları",
      "Gazların Özellikleri ve Gaz Yasaları",
      "İdeal Gaz Yasası",
      "Gazlarda Kinetik Teori",
      "Gaz Karışımları",
      "Derişim Birimleri",
      "Koligatif Özellikler",
      "Çözünürlük",
      "Tepkimelerde Isı Değişimi",
      "Oluşum Entalpisi",
      "Tepkime Isılarının Toplanabilirliği",
      "Tepkime Hızları",
      "Tepkime Hızını Etkileyen Faktörler",
      "Kimyasal Denge",
      "Dengeyi Etkileyen Faktörler",
      "Sulu Çözelti Dengeleri",
      "İndirgenme - Yükseltgenme Tepkimelerinde Elektrik Akımı",
      "Elektrotlar ve Elektrokimyasal Hücreler",
      "Elektrot Potansiyelleri",
      "Elektroliz",
      "Korozyon",
      "Basit Formül ve Molekül Formülü",
      "Doğada Karbon",
      "Hibritleşme - Molekül Geometrisi",
      "Hidrokarbonlar",
      "Fonksiyonel Gruplar",
      "Alkoller - Eterler",
      "Karbonil Bileşikleri",
      "Karboksilik Asitler",
      "Esterler"
    ],
    "Biyoloji": [
      "Denetleyici ve Düzenleyici Sistem, Duyu Organları",
      "Destek ve Hareket Sistemi",
      "Sindirim Sistemi",
      "Dolaşım Sistemi",
      "Solunum Sistemi",
      "Üriner Sistem",
      "Üreme Sistemi ve Embriyonik Gelişim",
      "Komünite ve Popülasyon Ekolojisi",
      "Genden Proteine",
      "Canlılık ve Enerji",
      "Fotosentez ve Kemosentez",
      "Hücresel Solunum",
      "Bitki Biyolojisi",
      "Canlılar ve Çevre"
    ],
    "Edebiyat": [
      "Anlam Bilgisi",
      "Metinlerin Sınıflandırılması",
      "Şiir Bilgisi",
      "Söz Sanatları",
      "Edebi Akımlar",
      "İslamiyet Öncesi ve Geçiş Dönemi Türk Edebiyatı",
      "Halk Edebiyatı",
      "Divan Edebiyatı",
      "Tanzimat Edebiyatı",
      "Servetifünun ve Fecriati Edebiyatı",
      "Milli Edebiyat",
      "Cumhuriyet Dönemi Türk Edebiyatı",
      "Masal/Fabl/Destan/Halk Hikayesi"
    ],
    "Tarih-1": [
      "Tarih ve Zaman",
      "İnsanlığın İlk Dönemleri",
      "Orta Çağ’da Dünya",
      "İlk ve Orta Çağlarda Türk Dünyası",
      "İslam Medeniyetinin Doğuşu",
      "Türklerin İslamiyet’i Kabulü ve İlk Türk İslam Dev.",
      "Yerleşme ve Devletleşme Sürecinde Selçuklu Türkiyesi",
      "Beylikten Devlete Osmanlı",
      "Devletleşme Sürecinde Savaşçılar ve Askerler",
      "Dünya Gücü Osmanlı",
      "Sultan ve Osmanlı Merkez Teşkilatı",
      "Değişen Dünya Dengeleri Karşısında Osmanlı Siyaseti",
      "Değişim Çağında Avrupa ve Osmanlı",
      "Uluslararası İlişkilerde Denge Stratejisi (1774-1912)",
      "Devrimler Çağında Değişen Devlet- Toplum İlişkileri",
      "Sermaye ve Emek",
      "XX. Yüzyıl Başlarında Osmanlı Devleti ve Dünya",
      "Milli Mücadele",
      "Atatürkçülük ve Türk İnkılabı",
      "İki Savaş Arasındaki Dönemde Türkiye ve Dünya",
      "II. Dünya Savaşı Sürecinde- Sonrasında Türkiye ve Dünya",
      "XXI. Yüzyılın Eşiğinde Türkiye ve Dünya"
    ],
    "Coğrafya-1": [
      "Ekosistemlerin Özellikleri ve İşleyişi",
      "Ekstrem Doğa Olayları",
      "Küresel İklim Değişikliği ve Doğa Olaylarının Geleceği",
      "Nüfus Politikaları ve Projeksiyonları",
      "Şehirler ve Kırsal Yerleşmeler",
      "Dünyada Doğal Kaynak ve Ekonomi",
      "Türkiye’de Tarım, Sanayi, Maden ve Enerji Kaynakları",
      "Ekonomi, Şehirleşme ve Göç",
      "İşlevsel Bölge ve Kalkınma Projeleri",
      "Hizmet Sektörünün Ekonomideki Yeri ve Ulaşım",
      "Türkiye’de ve Dünyada Ticaret",
      "Türkiye’de Turizm",
      "Kültür Bölgeleri ve Türk Kültürü",
      "Küreselleşen Dünya",
      "Uluslararası Örgütler",
      "Ülkeler Arası Etkileşim",
      "Jeopolitik Konum",
      "Çevre Sorunları ve Geri Dönüşüm",
      "Çevre Sorunlarının Çözümüne Yönelik Yaklaşımlar"
    ],
    "Tarih-2": [],
    "Coğrafya-2": [],
    "Felsefe Grubu": [
      "Felsefe ve Bilim",
      "Bilgi Felsefesi",
      "Varlık Felsefesi",
      "Ahlak Felsefesi",
      "Sanat Felsefesi",
      "Din Felsefesi",
      "20. Yüzyıl Felsefesi",
      "Mantığa Giriş",
      "Klasik Mantık",
      "Mantık ve Dil",
      "Psikoloji Bilimini Tanıyalım",
      "Psikolojinin Temel Süreçleri",
      "Öğrenme Bellek Düşünme",
      "Ruh Sağlığının Temelleri",
      "Sosyolojiye Giriş",
      "Birey ve Toplum",
      "Toplumsal Yapı",
      "Toplumsal Değişme ve Gelişme",
      "Toplum ve Kültür",
      "Toplumsal Kurumlar"
    ],
    "Din Kültürü": [
      "İslamda İbadet",
      "Allah, İnsan İlişkisi",
      "Kuran’a Göre Hz. Muhammed",
      "Kuran’da Bazı Kavramlar",
      "Kuran’dan Mesajlar",
      "İnançla İlgili Meseleler",
      "İslam ve Bilim",
      "Anadolu’da İslam",
      "İslam Düşüncesinde Tasavvufi Yorumlar ve Mezhepler",
      "Güncel Dini Meseleler",
      "Yaşayan Dinler"
    ],
    "YDT": [
      "Kelime Bilgisi"
    ]
  },
  YDT: {
    "İngilizce": [
      "Tenses (Present Simple, Present Continuous, Present Perfect)",
      "Tenses (Past Simple, Past Continuous, Past Perfect)",
      "Tenses (Future Simple, Future Continuous, Future Perfect)",
      "Modals (Can, Could, May, Might, Must, Should)",
      "Passive Voice",
      "Reported Speech",
      "Conditionals (Zero, First, Second, Third)",
      "Wish Clauses",
      "Relative Clauses",
      "Noun Clauses",
      "Adverbial Clauses",
      "Causatives",
      "Gerunds and Infinitives",
      "Participles",
      "Inversions",
      "Comparatives and Superlatives",
      "Articles and Determiners",
      "Prepositions",
      "Conjunctions (Coordinating, Subordinating, Correlative)",
      "Subject-Verb Agreement",
      "Pronouns and Reference",
      "Word Formation (Prefixes, Suffixes)",
      "Collocations and Idioms",
      "Vocabulary in Context",
      "Reading Comprehension - Main Idea",
      "Reading Comprehension - Details and Inferences",
      "Reading Comprehension - Vocabulary Questions",
      "Cloze Tests",
      "Paragraph Completion",
      "Dialogue Completion",
      "Sentence Completion",
      "Translation Techniques"
    ],
    "Almanca": [
      "Artikel und Nomen",
      "Pronomen",
      "Verbkonjugation (Präsens, Präteritum, Perfekt)",
      "Modalverben",
      "Passiv",
      "Konjunktiv II",
      "Relativsätze",
      "Nebensätze",
      "Adjektivdeklination",
      "Präpositionen",
      "Wortbildung",
      "Leseverstehen"
    ],
    "Fransızca": [
      "Les articles définis et indéfinis",
      "Les pronoms personnels",
      "La conjugaison (Présent, Passé composé, Imparfait)",
      "Le futur simple et le conditionnel",
      "Le subjonctif",
      "La voix passive",
      "Les propositions relatives",
      "Les prépositions",
      "Les adverbes",
      "La compréhension écrite"
    ]
  },
  LGS: {
    "Matematik": ["Çarpanlar ve Katlar", "Üslü İfadeler", "Kareköklü İfadeler", "Veri Analizi", "Olasılık", "Cebirsel İfadeler", "Doğrusal Denklemler", "Eşitsizlikler", "Üçgenler", "Eşlik ve Benzerlik", "Dönüşüm Geometrisi", "Geometrik Cisimler"],
    "Türkçe": ["Sözcükte Anlam", "Cümlede Anlam", "Paragrafta Anlam", "Fiilimsiler", "Cümlenin Ögeleri", "Yazım Kuralları", "Noktalama İşaretleri", "Metin Türleri", "Söz Sanatları", "Anlatım Bozuklukları"],
    "Fen Bilimleri": ["Mevsimler ve İklim", "DNA ve Genetik Kod", "Basınç", "Madde ve Endüstri", "Basit Makineler", "Enerji Dönüşümleri", "Elektrik Yükleri ve Elektrik Enerjisi"],
    "Sosyal Bilgiler": ["Bir Kahraman Doğuyor", "Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar", "Milli Bir Destan: Ya İstiklal Ya Ölüm!", "Atatürkçülük ve Çağdaşlaşan Türkiye", "Demokratikleşme Çabaları", "Atatürk Dönemi Türk Dış Politikası", "Atatürk'ün Ölümü ve Sonrası"],
    "İngilizce": ["Friendship", "Teen Life", "In The Kitchen", "On The Phone", "The Internet", "Adventures", "Tourism", "Chores", "Science", "Natural Forces"],
    "Din Kültürü": ["Kader İnancı", "Zekat ve Sadaka", "Din ve Hayat", "Hz. Muhammed'in Örnekliği", "Kur'an-ı Kerim ve Özellikleri"]
  }
};

const UNIVERSITIES = [
  "Boğaziçi Üniversitesi", "Orta Doğu Teknik Üniversitesi", "İstanbul Teknik Üniversitesi", "Hacettepe Üniversitesi",
  "Ankara Üniversitesi", "İstanbul Üniversitesi", "Ege Üniversitesi", "Gazi Üniversitesi", "Dokuz Eylül Üniversitesi",
  "Marmara Üniversitesi", "Yıldız Teknik Üniversitesi", "Bilkent Üniversitesi", "Koç Üniversitesi", "Sabancı Üniversitesi",
  "Galatasaray Üniversitesi", "Türk-Alman Üniversitesi", "Gebze Teknik Üniversitesi", "İzmir Yüksek Teknoloji Enstitüsü",
  "Anadolu Üniversitesi", "Akdeniz Üniversitesi", "Çukurova Üniversitesi", "Erciyes Üniversitesi", "Selçuk Üniversitesi",
  "Uludağ Üniversitesi", "Kocaeli Üniversitesi", "Sakarya Üniversitesi", "Eskişehir Osmangazi Üniversitesi",
  "Ondokuz Mayıs Üniversitesi", "Karadeniz Teknik Üniversitesi", "Atatürk Üniversitesi"
];

const DEPARTMENTS = {
  SAY: [
    "Tıp Fakültesi", "Diş Hekimliği", "Eczacılık", "Bilgisayar Mühendisliği", "Yazılım Mühendisliği",
    "Elektrik-Elektronik Mühendisliği", "Endüstri Mühendisliği", "Makine Mühendisliği", "İnşaat Mühendisliği",
    "Mimarlık", "Moleküler Biyoloji ve Genetik", "Havacılık ve Uzay Mühendisliği", "Yapay Zeka Mühendisliği",
    "Matematik Öğretmenliği", "Hemşirelik"
  ],
  EA: [
    "Hukuk Fakültesi", "Psikoloji", "İşletme", "İktisat", "Siyaset Bilimi ve Uluslararası İlişkiler",
    "Yönetim Bilişim Sistemleri", "Sınıf Öğretmenliği", "Rehberlik ve Psikolojik Danışmanlık",
    "Çocuk Gelişimi", "Sosyoloji", "Felsefe", "Bankacılık ve Finans", "Kamu Yönetimi",
    "Uluslararası Ticaret", "Grafik Tasarım"
  ],
  SOZ: [
    "Özel Eğitim Öğretmenliği", "Okul Öncesi Öğretmenliği", "Türkçe Öğretmenliği", "Tarih Öğretmenliği",
    "Coğrafya Öğretmenliği", "İlahiyat", "Gastronomi ve Mutfak Sanatları", "Radyo, Televizyon ve Sinema",
    "Halkla İlişkiler ve Tanıtım", "Gazetecilik", "Sanat Tarihi", "Reklamcılık", "Türk Dili ve Edebiyatı",
    "Tarih", "Coğrafya"
  ],
  DIL: [
    "İngilizce Öğretmenliği", "İngiliz Dili ve Edebiyatı", "Mütercim-Tercümanlık (İngilizce)", "Çeviribilim",
    "Almanca Öğretmenliği", "Fransızca Öğretmenliği", "Turizm Rehberliği", "Japonca Öğretmenliği",
    "Amerikan Kültürü ve Edebiyatı", "Kore Dili ve Edebiyatı", "Çin Dili ve Edebiyatı", "Rus Dili ve Edebiyatı",
    "İspanyol Dili ve Edebiyatı", "İtalyan Dili ve Edebiyatı", "Karşılaştırmalı Edebiyat"
  ]
};

// ============ SMART DAILY PLANNER CONFIGURATION ============

// Tempo Konfigürasyonu
export const TEMPO_CONFIG = {
  low: {
    min: 2,
    max: 3,
    default: 2,
    label: 'Düşük Tempo 🐢',
    description: '2-3 ders/gün',
    icon: '🐢',
    color: 'from-green-400 to-emerald-500'
  },
  medium: {
    min: 3,
    max: 5,
    default: 4,
    label: 'Orta Tempo 🚶',
    description: '3-5 ders/gün',
    icon: '🚶',
    color: 'from-blue-400 to-indigo-500'
  },
  high: {
    min: 6,
    max: 7,
    default: 6,
    label: 'Yüksek Tempo 🚀',
    description: '6-7 ders/gün',
    icon: '🚀',
    color: 'from-orange-400 to-red-500'
  }
} as const;

// Sınıf Bazlı Konfigürasyon
export const GRADE_CONFIG: Record<string, {
  mode: 'school' | 'yks' | 'lgs';
  hasFieldSelection: boolean;
  examTypes: ('TYT' | 'AYT' | 'YDT' | 'LGS' | '5. Sınıf' | '6. Sınıf' | '7. Sınıf' | '8. Sınıf' | '9. Sınıf' | '10. Sınıf' | 'Okul')[];
  defaultTempo: 'low' | 'medium' | 'high';
}> = {
  '5. Sınıf': { mode: 'lgs', hasFieldSelection: false, examTypes: ['LGS', '5. Sınıf'], defaultTempo: 'low' },
  '6. Sınıf': { mode: 'lgs', hasFieldSelection: false, examTypes: ['LGS', '6. Sınıf'], defaultTempo: 'low' },
  '7. Sınıf': { mode: 'lgs', hasFieldSelection: false, examTypes: ['LGS', '7. Sınıf'], defaultTempo: 'medium' },
  '8. Sınıf': { mode: 'lgs', hasFieldSelection: false, examTypes: ['LGS', '8. Sınıf'], defaultTempo: 'medium' },
  '9. Sınıf': { mode: 'school', hasFieldSelection: false, examTypes: ['TYT', 'Okul'], defaultTempo: 'low' },
  '10. Sınıf': { mode: 'school', hasFieldSelection: false, examTypes: ['TYT', 'Okul'], defaultTempo: 'low' },
  '11. Sınıf': { mode: 'yks', hasFieldSelection: true, examTypes: ['TYT', 'AYT'], defaultTempo: 'medium' },
  '12. Sınıf': { mode: 'yks', hasFieldSelection: true, examTypes: ['TYT', 'AYT'], defaultTempo: 'high' },
  'Mezun': { mode: 'yks', hasFieldSelection: true, examTypes: ['TYT', 'AYT'], defaultTempo: 'high' }
};

// YKS Zaman Çizelgesi (gün cinsinden)
export const YKS_TIMELINE = {
  tytDays: 75,      // 2.5 ay - TYT konularını bitirme süresi
  aytDays: 135,     // 4.5 ay - AYT konularını bitirme süresi
  reviewDays: 60,   // 2 ay - Tekrar ve deneme dönemi
  totalDays: 270    // Toplam hazırlık süresi (yaklaşık 9 ay)
};

// Planlayıcı Genel Ayarları
export const PLANNER_SETTINGS = {
  unlockHour: 0,           // Gece 00:00'da görevler açılır
  unlockMinute: 0,
  pointsPerVideo: 5,       // Video başına puan
  pointsPerQuestion: 10,   // Soru seti başına puan
  pointsPerComplete: 20,   // Tam tamamlama bonusu
  defaultQuestionCount: 15 // Varsayılan soru sayısı
};

// Alan Bazlı Ders Listesi
export const SUBJECTS_BY_FIELD = {
  // 9-10. Sınıf için genel dersler (alan yok)
  general: ['Matematik', 'Türkçe', 'Fizik', 'Kimya', 'Biyoloji', 'Tarih', 'Coğrafya', 'Felsefe', 'Din Kültürü'],

  // Sayısal
  SAY: {
    tyt: ['Matematik', 'Türkçe', 'Fizik', 'Kimya', 'Biyoloji', 'Tarih', 'Coğrafya', 'Felsefe', 'Din Kültürü'],
    ayt: ['Matematik', 'Geometri', 'Fizik', 'Kimya', 'Biyoloji']
  },

  // Eşit Ağırlık
  EA: {
    tyt: ['Matematik', 'Türkçe', 'Fizik', 'Kimya', 'Biyoloji', 'Tarih', 'Coğrafya', 'Felsefe', 'Din Kültürü'],
    ayt: ['Matematik', 'Geometri', 'Edebiyat', 'Tarih-1', 'Coğrafya-1']
  },

  // Sözel
  SOZ: {
    tyt: ['Matematik', 'Türkçe', 'Fizik', 'Kimya', 'Biyoloji', 'Tarih', 'Coğrafya', 'Felsefe', 'Din Kültürü'],
    ayt: ['Edebiyat', 'Tarih-1', 'Tarih-2', 'Coğrafya-1', 'Coğrafya-2', 'Felsefe Grubu', 'Din Kültürü']
  },

  // Yabancı Dil
  DIL: {
    tyt: ['Matematik', 'Türkçe', 'Fizik', 'Kimya', 'Biyoloji', 'Tarih', 'Coğrafya', 'Felsefe', 'Din Kültürü'],
    ayt: ['YDT'],
    ydt: ['İngilizce'] // veya Almanca/Fransızca
  },

  // LGS
  LGS: ['Matematik', 'Türkçe', 'Fen Bilimleri', 'Sosyal Bilgiler', 'İngilizce', 'Din Kültürü']
};

export const MIDDLE_SCHOOL_SUBJECTS = [
  "Türkçe",
  "Matematik",
  "Fen Bilimleri"
];

export const HIGH_SCHOOL_SUBJECTS = [
  "Türkçe",
  "Matematik",
  "Fizik",
  "Kimya",
  "Biyoloji",
  "Tarih",
  "Coğrafya",
  "Felsefe",
  "Din Kültürü ve Ahlâk Bilgisi",
  "Yabancı Dil"
];

// Gün İsimleri (Türkçe)
export const DAY_NAMES = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

// Renk Paleti (Dersler için)
export const SUBJECT_COLORS: Record<string, string> = {
  'Matematik': 'from-blue-500 to-indigo-600',
  'Geometri': 'from-blue-400 to-blue-600',
  'Türkçe': 'from-red-500 to-rose-600',
  'Edebiyat': 'from-pink-500 to-rose-600',
  'Fizik': 'from-purple-500 to-violet-600',
  'Kimya': 'from-green-500 to-emerald-600',
  'Biyoloji': 'from-teal-500 to-cyan-600',
  'Tarih': 'from-amber-500 to-orange-600',
  'Tarih-1': 'from-amber-500 to-orange-600',
  'Tarih-2': 'from-amber-400 to-orange-500',
  'Coğrafya': 'from-lime-500 to-green-600',
  'Coğrafya-1': 'from-lime-500 to-green-600',
  'Coğrafya-2': 'from-lime-400 to-green-500',
  'Felsefe': 'from-slate-500 to-gray-600',
  'Felsefe Grubu': 'from-slate-500 to-gray-600',
  'İngilizce': 'from-sky-500 to-blue-600',
  'Din Kültürü': 'from-yellow-500 to-amber-600',
  'Fen Bilimleri': 'from-cyan-500 to-teal-600',
  'Sosyal Bilgiler': 'from-orange-500 to-amber-600'
};


export const SUBJECT_ICONS: { [key: string]: any } = {
    'Matematik': CalculatorIcon,
    'Fizik': LightningBoltIcon,
    'Kimya': BeakerIcon,
    'Biyoloji': SparklesIcon,
    'Türkçe': FileTextIcon,
    'Tarih': GlobeIcon,
    'Coğrafya': MapIcon
};